import { render } from "./ChildPolicy20260901.vue?vue&type=template&id=cbe42196"
import script from "./ChildPolicy20260901.vue?vue&type=script&lang=js"
export * from "./ChildPolicy20260901.vue?vue&type=script&lang=js"

import exportComponent from "/apps/srv/jenkins/workspace/feihua_fe_mqimengweb_online/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__